/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

export const strings = {
  modified: 'modified on',
  back: 'Back',
  next: 'Next',
  pages: 'pages',
  page: 'Page'
};
